<template>
    <div :class="['Tab', { Selected: props.selected }]">
        {{ props.text }}
    </div>
</template>
<script setup lang="ts">
    const props = defineProps({
        text: {
            type: String,
            required: true
        },
        selected: {
            type: Boolean,
            default: false
        }
    });
</script>
<style scoped lang="scss">
    .Tab {

        color: $Grey-900;
        cursor: pointer;
        @include TextStyle(UiMediumRegular);
        @include PaddingAreas(0, 0, 0.5, 0);

        @include Breakpoint(Medium, Large, ExtraLarge) {
            @include TextStyle(UiLargeRegular);
        }

        &.Selected {
            color: $Blue-700;
            border-bottom: 4px solid $Blue-700;
            @include TextStyle(UiMediumSemibold);

            @include Breakpoint(Medium, Large, ExtraLarge) {
                @include TextStyle(UiLargeBold);
                border-bottom: 3px solid $Blue-700;
            }
        }
    }
</style>